import React, { lazy, Suspense } from "react";
import NavbarComponent from "./Navbar";
import styled, { createGlobalStyle } from "styled-components";
import { Container } from "react-bootstrap";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap');

  body {
    font-family: 'Poppins', sans-serif;
    background: linear-gradient(to right, #f5f7fa, #c3cfe2);
  }
`;

const FooterInsert = lazy(() => import("./FooterInsert"));

const ComplaintsContainer = styled(Container)`
  margin-top: 300px;
  margin-bottom: 100px;
`;

const StyledListTitle = styled.h5`
  font-weight: bold;
`;
const Complaints_policy = () => {
  return (
    <div>
      <GlobalStyle />
      <NavbarComponent />

      <ComplaintsContainer>
        <h1>Complaints Policy</h1>
        <p>This complaints policy was last updated July 2025.</p>
        <br/>
        <div>
          <p>Retail Park:</p>
          <ol className="list-dot">
            <li>will take seriously any concern or complaint and will investigate it promptly, for resolution as quickly as possible;</li>
            <li>recognises that the public:
              <ol className="list-dot-disc">
                <li>have the right to raise concerns or complaints about our services</li>
                <li>have access to clear information on how to voice complaints and concerns;</li>
              </ol>
            </li>
            <li>confirms that the complaints procedure is open to everyone who have any interaction with Retail Park;</li>
            <li>will produce this policy and procedure which will be on display and available to anyone who asks for it;</li>
            <li>will deal with complaints in line with this policy;</li>
            <li>will keep a register of all complaints in line with regulations;</li>
            <li>confirms that the complaints procedure will be part of the process of monitoring the quality, effectiveness and non-discriminatory nature of Retail Park’s services</li>
          </ol>
        </div>
        <br/>
        <div>

        <StyledListTitle>1. Introduction</StyledListTitle>
          <p>
            Retail Park strives for high standards in service delivery and welcomes feedback from individuals and users of our services on all aspects of our services. Such feedback is invaluable in helping us evaluate and improve our work.
          </p>
          <p>The objectives of Retail Park’s complaints policy and procedures are to:</p>
          <ol className="list-dot">
            <li>Ensure everyone knows how to make a complaint and how a complaint will be handled</li>
            <li>Ensure that complaints are dealt with consistently, fairly and sensitively within clear time frames</li>
            <li>Provide individuals with a fair and effective way to complain about our work and services</li>
            <li>Ensure that complaints are monitored to improve our services and processes.</li>
          </ol>
          <br/>
          <p>Retail Park will ensure that we:</p>
          <ol className="list-dot">
            <li>Listen carefully to complaints and treat complaints as confidential, where possible</li>
            <li>Record, store and manage all complaints accurately and in accordance with the Data Protection Act and other Regulations Retail Park needs to adhere to</li>
            <li>Investigate the complaint fully, objectively and within the stated time frame</li>
            <li>Notify the complainant of the results of the investigation and any right of appeal or escalation</li>
            <li>Inform the complainant of any action that will be implemented in order to ensure that there is no re-occurrence.</li>
          </ol>
        </div>
        <br />
        <div>
          <StyledListTitle>2. Policy Scope</StyledListTitle>
          <p>
            A complaint is any expression of dissatisfaction by an individual, whether justified or not. An individual may make a complaint if they feel Retail Park has:
          </p>
          <ol className="list-dot">
            <li>Failed to provide a service or an acceptable standard of service</li>
            <li>Made a mistake in the way the service was provided</li>
            <li>Failed to act in a proper way</li>
            <li>Provided an unfair service</li>
          </ol>
          <p>This policy and procedure relate only to complaints received about Retail Park and its services</p>
        </div>
        <br />
        <div>
          <StyledListTitle>3. Definition of a complaint</StyledListTitle>
          <p>
            A complaint is any expression of dissatisfaction by an individual, whether justified or not. An individual may make a complaint if they feel Retail Park has:
          </p>
        </div>
        <br/>
        <div>
          <StyledListTitle>4. Confidentiality</StyledListTitle>
          <p>
            All complaints will be treated in confidence. We will only share the identity of the individual or the details of the complaint with a third party with the individual’s consent, or if required by regulatory bodies and legislation. 
          </p>
        </div>
        <br/>
        <div>
          <StyledListTitle>4. Making a complaint</StyledListTitle>
          <p>
            It is important to note; the complaints policy and procedure cannot be used as a channel for complainants to appeal their Parking Charge Notice (PCN). Matters relating specifically to parking contraventions must be made via the correct appeal method as stated on Retail Park’s notices and website. 
          </p>
          <p>Retail Park has a dedicated Complaints mailbox for all complaints - <a href="mailto:enquiries@retailparkuk.co.uk">enquiries@retailparkuk.co.uk</a></p>
          <p>
            A complaint can arrive in the following way:
          </p>
          <ol className="list-dot">
              <li>Directly to the Complaints inbox managed by Retail Park’s Complaints Team;</li>
              <li>Written correspondence submitted against a parking charge through Retail Park’s web portal;</li>
              <li>Written correspondence submitted by post, addressed to Retail Park in the form of a letter;</li>
              <li>Complaints made by proxy to the client, who will forward the complaint to the appropriate account manager or to the Sales inbox;</li>
              <li>Queries raised via email to the DPO inbox;</li>
              <li>Complaints raised by email to a member of the Senior Management Team or C-Suite;</li>
              <li>Disputes raised directly to the British Parking Association (BPA) in the first instance or any other association;</li>
              <li>Directly to a Warden whilst patrolling a site.</li>
          </ol>
        </div>
        <br/>
        <div>
          <StyledListTitle>5. Type of complaints Retail Park receives</StyledListTitle>
          <ol className="list-dot">
              <li>Site/Signage complaints</li>
              <li>Health and Safety complaints</li>
              <li>Data Subject Rights complaints</li>
              <li>Generic/PCN complaints regarding how an appeal was dealt with or how a Parking Attendant interacted with a member of the public</li>
          </ol>
        </div>
        <br/>
        <div>
          <StyledListTitle>6. Complaints Procedure</StyledListTitle>
          <p>Complaints should be sent directly to <a href="mailto:enquiries@retailparkuk.co.uk">enquiries@retailparkuk.co.uk</a> or write to us at Retail Park Ltd, PO Box 6142, Sheffield, S2 9JA.</p>
          <p>There are three stages to the complaint’s procedure:</p>
          <ol className="list-dot">
              <li>Stage One – The Complaint/Investigation</li>
              <li>Stage Two – Further Investigation (if not resolved in Stage One)</li>
              <li>Stage Three – External Escalation Process</li>
          </ol>
          <p>Stage One</p>
          <ol className="list-dot">
            <li>Upon receiving a complaint, the Case Management Team will record the complaint on Retail Park’s Complaints Log</li>
            <li>An acknowledgement email will be issued to the complainant within 14 days of its receipt unless exceptional circumstances apply, in which case the complainant will be informed.</li>
            <li>As a general rule, the acknowledgement will confirm we have received the complaint and it has either been issued to the relevant department to resolve or is being handled by the Case Management Team who will respond within 28 days of its receipt.</li>
            <li>If Retail Park cannot respond within this timescale, i.e. further investigation needs to be conducted, we will inform the complainant of the delay and give an indication of when a full response will be sent to them.</li>
            <li>The Case Handler will assess the content of the complaint, providing a response that will contain:
              <ol className="list-dot-disc">
                <li>Parking Charge Notice (PCN) timeline to date;</li>
                <li>Explanation of the steps Retail Park has taken to reach this stage and addressing all the points raised within the complaint;</li>
                <li>Copies of any relevant documentation to assist in adding clarity to the complaint;</li>
                <li>Outline any proposed rectifying actions/outcomes to the complaint;</li>
                <li>Provide information in relation to next steps that are to be taken if complainant is unsatisfied with our response.</li>
              </ol>
            </li>
          </ol>
          <p>Please be advised that at any time during this stage, the Case Management team might request some form of identification to ensure that the complainant is the authorised recipient of the relevant information.</p>
          <p>Stage Two</p>
          <ol className="list-dot">
            <li>If the complaint cannot be resolved to the complainant’s satisfaction by the Case Handler, or if the Case Handler feels that the complaint is of a very serious nature, the complaint will then be passed to the Case Manager who will review the complaint and respond appropriately.</li>
            <li>The Case Handler who dealt with the original correspondence at Stage One will be kept informed of the ongoing investigation and will update the Complaints Log accordingly.</li>
            <li>The complaint at Stage Two will be responded to within 28 days of receipt of the complainant’s dissatisfied response to us. If this is not possible, i.e. further investigation needs to be conducted, we will inform the complainant of the delay and give an indication of when a full response will be sent to them.</li>
            <li>Whether or not the complaint is upheld, the response to the complainant will detail the action taken to investigate the complaint, the conclusions from the investigation, and any action taken internally because of the complaint.</li>
            <li>The decision taken at this stage is final unless the Case Manager decides it is appropriate to seek external assistance with resolution.</li>
            <li>Please be advised that at any time during this stage, the Case Management team might request some form of identification to ensure that the complainant is the authorised recipient of the relevant information.</li>
          </ol>
          <p>Stage Three</p>
          <p>If the complainant is dissatisfied with the response from the Case Manager at Stage Two, the third and final step is for Retail Park to advise the complainant to make a formal complaint with the BPA who will investigate the matter. </p>
          <br/>
          <p>Please note, a complaint submitted to Retail Park and the BPA are considered as two different complaint procedures and will not be dealt with simultaneously.</p>
        </div>
        <br/>
        <div>
          <StyledListTitle>7. Anonymous Complaints</StyledListTitle>
          <p>Complaints received anonymously will be recorded and considered, but action may be limited if further information is required to ensure a full and fair investigation.</p>
        </div>
        <br/>
        <div>
          <StyledListTitle>8. Monitoring and record-keeping</StyledListTitle>
          <p>To ensure Retail Park can learn from complaints, the following data may be collected:</p>
          <ol className="list-lower-alpha">
            <li>the date of complaint;</li>
            <li>a copy of the complaint;</li>
            <li>a copy of all correspondence;</li>
            <li>the outcome; and</li>
            <li>the details of any corrective action required</li>
          </ol>
          <p>Complaints information will be reviewed on a regular basis by the Head of Operations and regularly audited by the Compliance Team.</p>
          <p>As per the requirements set out by the BPA, and for audit purposes, we will retain a record of all complaints for 36 months, and this record will be made available on request to authorised bodies.</p>
        </div>
      </ComplaintsContainer>

      <Suspense fallback={<div>Loading...</div>}>
        <FooterInsert />
      </Suspense>
    </div>
  );
};

export default Complaints_policy;
